<div class="conduit-settings-container">
    <sysque-options-line 
      [sysqueOption]="options" 
      (switchClicked)="onSwitchClicked($event)">
    </sysque-options-line>
    <div class="image-container">
        <canvas id="conduit-settings-canvas" class="canvas">
        </canvas>
    </div>
</div>